module.exports = __webpack_public_path__ + "static/about2-cb92979262c9fca0c6ae229fc3c73491.svg";